import { GET_EXPERIENCEDETAILS_BY_STUDENTID } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_EXPERIENCEDETAILS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getExperienceDetailsByStudentId.js